export default __webpack_public_path__ + "static/media/KR_Text_World6.22232586.svg";